module.exports = __webpack_public_path__ + "img/top_33.ac6f3674.png";